module.exports = __webpack_public_path__ + "img/04_slides.0f503fd1.png";